import { initContract } from "@ts-rest/core";
import z from "zod";

import {
  clinicSchema,
  patientSchema,
  updatePatientSchema,
} from "@libs/db-schemas";

import { HTTPStatusCode } from "../../types";
import { errorSchema } from "../../utils/errors";

const c = initContract();

export const patientsContract = c.router({
  getCurrentPatient: {
    summary: "Get the current authenticated patient",
    method: "GET",
    path: "/patients/me",
    responses: {
      [HTTPStatusCode.OK]: patientSchema,
      [HTTPStatusCode.NOT_FOUND]: errorSchema,
    },
  },
  updateCurrentPatient: {
    summary: "Update the current authenticated patient",
    method: "PATCH",
    path: "/patients/me",
    body: updatePatientSchema.pick({
      applicationLastStep: true,
      preferredLanguage: true,
    }),
    responses: {
      [HTTPStatusCode.OK]: patientSchema,
      [HTTPStatusCode.BAD_REQUEST]: errorSchema,
      [HTTPStatusCode.NOT_FOUND]: errorSchema,
      [HTTPStatusCode.INTERNAL_SERVER_ERROR]: errorSchema,
    },
  },
  listClinics: {
    summary: "List clinics for the current authenticated patient",
    method: "GET",
    path: "/patients/me/clinics",
    responses: {
      [HTTPStatusCode.OK]: z.array(clinicSchema),
    },
  },
});
